import React from 'react';
import styled from 'styled-components';
import { Dialog } from '@progress/kendo-react-dialogs';
import { palette } from '../../../system/styles/styles';
import { useTranslation } from 'react-i18next';
import ViewPdf from './viewPDF';
import { pdfjs } from 'react-pdf';
import { useSelector, useDispatch } from 'react-redux';
import { Close } from '@styled-icons/evil';
import database, { storage } from '../../../system/model/firebase/firebase';
import Menu from './Modal/Menu';
import GeneralStep from './Modal/GeneralStep';
import CalificationStep from './Modal/CalificationsStep';
import CommentsStep from './Modal/CommentsStep';
import TranferirStep from './Modal/TransferirStep';
import TestStep from './Modal/TestStep';
import Star from '../../../system/access/images/ats/star.png';
import Stargolden from '../../../system/access/images/ats/star__golden.png';
import { Modal } from '@material-ui/core';
import { Delete_Save_Candidate, Save_Candidate, Transfer_Candidate } from '../../../redux/actions/backendActions';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const ModalMine = styled(Modal)`
  padding: 16px 32px;
  font-family: futura-pt, sans-serif;
  color: #656565;
  header {
    background-color: ${palette.black};
    color: ${palette.white};
    font-size: 18px;
    height: 40px;
    display: flex;
    justify-items: center;
    align-items: center;
    padding-left: 20px;
    text-transform: uppercase;
    position: relative;
    border-radius: 7px 7px 0 0;
  }
  .k-dialog-buttongroup {
    display: grid;
    grid-template-columns: 50% 50%;
    button {
      width: 50%;
      justify-self: center;
      height: 25px;
      cursor: pointer;
    }
    .cancel {
      background: none;
      border: none;
      font-weight: 400;
      color: ${palette.red};
    }
    .save {
      background: none;
      border: none;
      font-weight: 400;
      background-color: ${palette.blue};
      color: ${palette.white};
      border-radius: 10px;
    }
  }
  .containerBody {
    width: 95vw;
    height: 97vh;
    overflow-y: auto;
  }
  .grid--applicant--modal {
    display: grid;
    grid-template-columns: 60% 40%;
    height: calc(97vh - 50px);
    background-color: ${palette.white};
    overflow-y: auto;
    border-radius: 0 0 7px 7px;
  }
  .icon {
    width: 35px;
    position: absolute;
    top: 3px;
    right: 3px;
    cursor: pointer;
  }
  .second--box {
    width: 100%;
    height: calc(100vh - 50px - 5%);
    background-color: ${palette.white};
    border-bottom-right-radius: 8px;
  }
`;

const ModalCandidate = (props) => {
  const {
    info,
    pageNumber,
    go_back,
    advance_page,
    load_success,
    sendComment,
    postStar,
    updateStar,
    jobID,
    Load_Save,
    close,
    saveEditComment,
    openModal,
  } = props;
  const dispatch = useDispatch();
  const comments = useSelector((state) => state.applicant?.comments);
  const Company = useSelector((state) => state.company);
  const uid = useSelector((state) => state.auth.uid);
  const post = useSelector((state) => state.applicant?.post);
  const promedio = useSelector((state) => state.applicant?.promedio);
  const history = useSelector((state) => state.applicant?.history);
  const star = useSelector((state) => state.applicant?.calificacion);
  const jobs = useSelector((state) => state.vacancies);
  const SaveCandidate = useSelector((state) => state.vacancy?.SaveCandidate);
  const vacancyOwner = useSelector((state) => state.vacancy?.id_Vacancy);
  const { t } = useTranslation(['admin']);
  const [state, setState] = React.useState({
    data: '',
    index: -1,
    editdata: '',
    indexModal: 0,
    star: 0,
    divStar: [],
    updateStar: false,
    vacancyOwner: '',
    Preload: false,
    pages: 0,
    info,
  });
  const userEmail = useSelector((state) => state.auth.userData.email);

  // Se trato traer la mayor cantidad de metodos solo corrigiendo algunos detalles
  const onClick_Transfer = (value) => {
    dispatch(Transfer_Candidate({ ...value }, info));
  };

  const updateStarCont = async (star) => {
    const docID = info.docID;
    const Star = info.stars || false;
    const idColumn = info.idColumn;
    updateStar({ star, docID, Star }, idColumn);
    await setState((prev) => ({ ...prev, updateStar: false }));
  };

  const onClickStar = async (star = 0) => {
    const startPersonal = info.stars?.items.find((item) => item.email === userEmail);
    await setState((prev) => ({ ...prev, star }));
    if (!startPersonal) {
      postStarCont(star);
      start(star);
    } else {
      await updateStarCont(star);
      start(star);
    }
  };

  const start = (pro = false) => {
    const divStar = [];
    const promedioFind = pro ? pro : +info?.stars?.promedio || 0;
    for (let i = 0; i < promedioFind; i++) {
      divStar.push(<img key={i} onClick={() => onClickStar(i + 1)} src={Stargolden} alt={`${i} de 5 estrellas`} />);
    }
    for (let i = promedioFind; i < 5; i++) {
      divStar.push(<img key={i} onClick={() => onClickStar(i + 1)} src={Star} alt={`${i} de 5 estrellas`} />);
    }
    setState((prev) => ({ ...prev, divStar }));
    // return divStar;
  };
  const postStarCont = (star) => {
    // const { star } = state;
    const docID = info.docID;
    const Star = info.stars || false;
    const idColumn = info.idColumn;
    console.log({ star, docID, Star }, idColumn);
    postStar({ star, docID, Star }, idColumn);
  };

  const onClickUpdate = async () => {
    setState((prev) => ({
      ...prev,
      updateStar: true,
      star: star,
    }));
    start();
  };
  const sendData = (data) => {
    setState((pre) => ({
      ...pre,
      data: data,
    }));
  };
  const editComment = (index) => {
    setState((prev) => ({ ...prev, index }));
  };
  const _updateDataModal = (data) => {
    setState((prev) => ({ ...prev, data }));
  };
  const _updateEditable = async (editdata, index) => {
    await setState((prev) => ({
      ...prev,
      editdata,
    }));
    await editComment(index);
  };
  const saveEditCommentOn = (editdata, index) => {
    const docID = info.docID;
    const idColumn = info.idColumn;
    saveEditComment(editdata, index, docID, idColumn);
    setState((prev) => ({ ...prev, editdata: '' }));
    editComment(-1);
  };
  const sendEditData = (editdata) => {
    setState((prev) => ({ ...prev, editdata }));
  };

  // Fin
  const updateCV = async (filename) => {
    const imgURL = await storage.ref('cves').child(filename).getDownloadURL();
    await database
      .collection('companies')
      .doc(uid)
      .collection('jobs')
      .doc(vacancyOwner)
      .collection('organicCanidate')
      .doc(info.docID)
      .update({
        cv: imgURL,
        fileID: filename,
      });
    document.location.reload();
  };

  const Toggle_Preload = () => {
    setState((prevState) => ({
      ...prevState,
      Preload: prevState.Preload,
    }));
  };

  const onClick_Delete_Candidate = async () => {
    await Toggle_Preload();
    await dispatch(Delete_Save_Candidate(info.Save[0].key));
    await Toggle_Preload();
  };

  const onClick_Save_Candidate = async () => {
    await Toggle_Preload();
    await dispatch(
      Save_Candidate({
        ...info,
      })
    );
    await Toggle_Preload();
  };

  const changedState = (key, value) => {
    setState((prev) => ({ ...prev, [key]: value }));
  };

  const sendEmail = () => {
    window.location.href = `mailto:${info.email}`;
  };

  React.useEffect(() => {
    // const funcInit = async () => {
    //   await setS
    start();
    // }
  }, []);
  React.useEffect(() => {
    Load_Save();
  }, [SaveCandidate]);

  const getView = () => {
    switch (state.indexModal) {
      case 1:
        return (
          <CommentsStep
            comments={comments}
            docID={info.docID}
            idColumn={info.idColumn}
            id={uid}
            _index={state.index}
            data={state.data}
            editdata={state.editdata}
            editComment={editComment}
            sendEditData={sendEditData}
            saveEditComment={saveEditCommentOn}
            sendData={sendData}
            sendComment={sendComment}
            _updateEditable={_updateEditable}
            _updateDataModal={_updateDataModal}
          />
        );
      case 2:
        return (
          <CalificationStep
            post={post}
            promedio={promedio}
            history={history}
            updateStar={state.updateStar}
            divStar={state.divStar}
            onClickUpdate={onClickUpdate}
            timestamp={info.timestamp}
          />
        );
      case 3:
        return <TranferirStep jobs={jobs} onClick_Transfer={onClick_Transfer} />;
      case 4:
        return <TestStep data={info} id={jobID} docID={info.docID} />;
      case 0:
      default:
        return (
          <GeneralStep
            names={state.info.names}
            lastNames={state.info.lastNames}
            time={info.time}
            email={info.email}
            phoneNumber={info.phoneNumber}
            longDescription={info.longDescription}
            companyName={Company.companyName}
            onClick={sendEmail}
          />
        );
    }
  };

  return (
    <ModalMine open={openModal}>
      <section className="containerBody">
        <header>
          {' '}
          Detalles del postulante{' '}
          <span>
            {' '}
            <Close className="icon" onClick={close} />{' '}
          </span>{' '}
        </header>
        <div className="grid--applicant--modal">
          <ViewPdf
            pageNumber={pageNumber}
            go_back={go_back}
            advance_page={advance_page}
            load_success={load_success}
            cv={info.cv}
            fileID={info.fileID}
            updateCV={updateCV}
            id={uid}
            vacancyOwner={vacancyOwner}
            docID={info.docID}
          />
          <div className="second--box">
            <Menu
              indexModal={state.indexModal}
              names={info.names}
              lastNames={info.lastNames}
              Save={info.Save}
              // typeUser={this.props.typeUser}
              deleteCandidate={onClick_Delete_Candidate}
              saveCandidate={onClick_Save_Candidate}
              changedState={changedState}
              docID={info.docID}
            />
            <div>{getView()}</div>
          </div>
        </div>
      </section>
    </ModalMine>
  );
};

export default ModalCandidate;
